import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config.js";
import i18n from "../../../functions/i18next";

export default {
  props: {
    itemData: Object,
  },
  data() {
    return {
      user: [],
      deleted: false,
      error: false,
      message: "",
    };
  },
  created() {
    this.user = this.itemData;
  },
  methods: {
    deleteUser() {
      let formData = new FormData();
      formData.append("id", this.user.id);
      this.$axios
        .post(baseUrl + "/userstate", formData)
        .then((response) => {
          if (response.data) {
            this.deleted = true;
            this.message = i18n.t("manage_users.user_deleted");
            EventBus.$emit("get-all-users");
          } else {
            this.error = true;
            this.message = i18n.t("common.something_went_wrong");
          }
        })
        .catch((thrown) => {
          this.error = true;
          this.message = i18n.t("common.something_went_wrong");
        });
    },
    /**
     * Close the user delete screen
     */
    close() {
      EventBus.$emit("close-manage-user-actions");

      if (deleted) {
        EventBus.$emit("get-all-users");
      }
    },
  },
};
